import { NavigateFunction } from "react-router-dom"

type AuthBackground = {
    pathname: string
    search?: string
    hash?: string
}

/** Открыть /auth как модалку над `from`. `replace` — когда уходим со страницы, которая снова редиректит гостя. */
export function openAuth(
    navigate: NavigateFunction,
    from: AuthBackground,
    options?: { replace?: boolean },
) {
    navigate("/auth", {
        replace: options?.replace ?? false,
        state: {
            backgroundLocation: {
                pathname: from.pathname,
                search: from.search ?? "",
                hash: from.hash ?? "",
            },
        },
    })
}
